export class NotaRequest {
    constructor({
        filialId = null,
        naturezaId = null,
        dataLanIni = null,
        dataLanFim = null,
        usuarioId = null,
        clienteId = null,
        clienteNome = null,
        fornecedorId = null,
        vendedorId = null,
        situacaoNF = null,
        numDoc = null,
        caixaId = null,
        formaPagId = null,
        grupoId = null,
        marcaId = null,
        produtoId = null
    } = {}) {
        this.filialId = filialId;
        this.naturezaId = naturezaId;
        this.dataLanIni = dataLanIni;
        this.dataLanFim = dataLanFim;
        this.usuarioId = usuarioId;
        this.clienteId = clienteId;
        this.clienteNome = clienteNome;
        this.fornecedorId = fornecedorId;
        this.vendedorId = vendedorId;
        this.situacaoNF = situacaoNF;
        this.numDoc = numDoc;
        this.caixaId = caixaId;
        this.formaPagId = formaPagId;
        this.grupoId = grupoId;
        this.marcaId = marcaId;
        this.produtoId = produtoId;
    }

    // Método para converter a classe em parâmetros de consulta
    toQueryString() {
        const params = new URLSearchParams();
        Object.entries(this).forEach(([key, value]) => {
            if (value !== null && value !== undefined) {
                params.append(key, value);
            }
        });
        return params.toString();
    }
}
